/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.publicQrCodeScan.internal

import features.publicQrCodeScan.models.PublicQrCodeScanResponseModel
import features.publicQrCodeScan.models.ScanPublicQrCodeRequest
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class ScanningPublicQrCodeServiceImpl : ScanningPublicQrCodeService {

    private val scanningPublicQrCodeRequest = ScanningPublicQrCodeRequest()

    override suspend fun scanPublicQrCode(
        overrideHeaders : Map<String, String>?,
        scanPublicQrCodeRequest: ScanPublicQrCodeRequest    ): Result<PublicQrCodeScanResponseModel> {
        return scanningPublicQrCodeRequest.scanPublicQrCode(
            overrideHeaders = overrideHeaders,
            scanPublicQrCodeRequest = scanPublicQrCodeRequest        ).toModel()
    }
}
